import { Button } from '@pwc/pwc-deals-ui';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import _ from 'lodash';

import {
  fetchSurveyResponses,
  getSurveyResponses,
} from '../../../../Survey/surveySlice';
import SectionNav from './SectionNav/SectionNav';

import './SurveySidebar.scss';
import { SurveyServiceClient } from '../../../services/httpClient';
import {
  CONTENT_TYPE_SURVEY,
  formatContentResponsesRoute,
} from '../../../../Survey/routes';
import ReviewResponsesNavItem from './ReviewResponsesNavItem/ReviewResponsesNavItem';
import featureFlags from '../../../helpers/featureFlags';

const addCompletionStatuses = (sections, sectionCompletionStatus) =>
  sections.map((section) => {
    const completionStatuses = sectionCompletionStatus;
    const completionStatus = completionStatuses.find(
      (cs) => cs.sectionId === section.id
    );
    return { ...section, ...completionStatus };
  });

const SurveySideBar = () => {
  const { projectId } = useParams();
  const dispatch = useDispatch();

  const surveyResponses = useSelector(getSurveyResponses);

  const [sections, setSections] = useState([]);
  const [prefillSurveyError, setPrefillSurveyError] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (surveyResponses) {
      const sectionsWithCompletionStatus = addCompletionStatuses(
        surveyResponses.sections,
        surveyResponses.sectionCompletionStatus
      );
      setSections(sectionsWithCompletionStatus);
    }
  }, [surveyResponses]);

  const prefillSurvey = async () => {
    try {
      await SurveyServiceClient(projectId).post(
        `/projects/${projectId}/answers/prefill`
      );
      setPrefillSurveyError(null);
      dispatch(fetchSurveyResponses(projectId));

      const expectedRoute = formatContentResponsesRoute(
        projectId,
        CONTENT_TYPE_SURVEY
      );

      history.push(expectedRoute);
    } catch (err) {
      setPrefillSurveyError('Unable to prefill survey');
    }
  };

  const sortedSections = _.sortBy(sections, 'order');

  return (
    <div className="survey-sidebar-container">
      <div className="survey-sidebar-header">Diagnostic Questionnaire</div>
      {sortedSections.map((section) => (
        <SectionNav key={section.id} section={section} />
      ))}
      <div className="response-results">
        <ReviewResponsesNavItem content="survey" navText="Review Responses" />
      </div>
      {featureFlags.diagnosticDebuggingControls && (
        <div className="prefill-survey-container">
          <Button className="prefill-survey-button" onClick={prefillSurvey}>
            Prefill Survey
          </Button>
          {prefillSurveyError && (
            <span className="prefill-survey-error">{prefillSurveyError}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default SurveySideBar;
